import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import ManagedSolutionsApplicationsTable from "../../components/ManagedSolutionsApplications/ManagedSolutionsApplicationsTable"
import {usePaging} from "../../hooks/usePaging"
import {useAccessToken} from "../../services/auth"
import {findManagedSolutionsApplications, exportManagedSolutionsApplications} from "../../resources/managedSolutions"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {DataTableActionHeader, DataTableCard, TablePending} from "../../components/DataTable/DataTable"
import {useQueryState} from "use-location-state"
import {downloadFile} from "../../utilities/file"
import {useToasts} from "react-toast-notifications"

export function ManagedSolutionsApplicationsPage(): ReactElement {
	const accessToken = useAccessToken()
	const {addToast} = useToasts()
	const limit = 40

	const [sortBy, setSortBy] = useQueryState("rtl-app--sort", "-createdAt")

	const [result, hasPrev, hasNext, prev, next, hasResults, reset] = usePaging(
		limit,
		(offset, limit) => findManagedSolutionsApplications(accessToken, offset, limit, sortBy),
		(x) => x.data.length,
		[sortBy],
		"rtl-app",
		true
	)

	const toggleSort = () => {
		setSortBy(sortBy === "-createdAt" ? "createdAt" : "-createdAt")
		reset(limit)
	}

	async function exportApplications() {
		const response = await exportManagedSolutionsApplications(accessToken, sortBy)
		response.match(
			(d) => downloadFile("ManagedSolutionsApplications.csv", d, "text/csv"),
			() => addToast("Something went wrong", {appearance: "warning"})
		)
		return true
	}

	return (
		<>
			<TitleBar title={"Applications"} />

			<MainSectionTable>
				<DataTableCard className={"managed-solutions-applications-card"}>
					<DataTableActionHeader enableSticky={true} exportFunc={exportApplications} />
					<AsyncResultComponent asyncResult={result} pendingComponent={<TablePending numberOfRows={2} />}>
						{({value: applications}) => {
							return (
								<ManagedSolutionsApplicationsTable
									applications={applications.data}
									hasResults={hasResults}
									hasPrev={hasPrev}
									hasNext={hasNext}
									prev={prev}
									next={next}
									isUsingPaging={true}
									fullHeight={true}
									meta={applications.meta}
									sortBy={sortBy}
									sortFunction={toggleSort}
								/>
							)
						}}
					</AsyncResultComponent>
				</DataTableCard>
			</MainSectionTable>
		</>
	)
}
